import type { FaireProductEntity } from "../../entity_types/product";

export const p_jzhrmdhjp9: FaireProductEntity = {
  token: "p_jzhrmdhjp9",
  type: "product",
  name: "Moroccan Cone Glassware Large - Green",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/8607744fc0906b6161515c05b8d1fd49b30e87a2e1fb3ba5ee72db6633dfa31b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5878ce9de2df9aac395282bae8cf5f096cc5573dac396f193dd027389e611b53.jpeg",
    "https://cdn.faire.com/fastly/a44410568900e3d994d2eba92df53ce031375e8db92931bb7db2f812609c79bd.jpeg",
    "https://cdn.faire.com/fastly/22a89f4d9acf04dcde676f172a2ea91c96a480bb6ea5f50508a65821bc22c6ef.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/65299be51b8b7572479ecef4d3672b8b84fbd5a1d363912fe28413f595c88c8d.jpeg",
    "https://cdn.faire.com/fastly/c00d7f9850c9abdf48bb1054946f07750ecee6ced09f47722f1ddd75dfdb2117.jpeg",
    "https://cdn.faire.com/fastly/de83ab92e01793e88911aaa8f4f42a7d6f9328b46870122e8b1912f07c70396f.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
    "https://cdn.faire.com/fastly/84be0b11d448f908237eb1f7d1cd6a708dc4d26272af85602fc6563ca2fc5968.jpeg",
    "https://cdn.faire.com/fastly/530c485ec28fd2962803385ac68460d941b2cff1f9516dbc3fdc41694d0442b8.jpeg",
  ],
  priceDollars: 4.2,
  description:
    '**Packaged in sets of 6** - 24 single glasses in a master\nSee separate listings for each color option.\n\nThe sleek and simple design of these hand-blown cone shaped glasses are a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. Works as a beautiful floral vase, too!\n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nMade from recycled beer and wine bottles, these sets are a second act for glass that would otherwise be sent to landfills. \n\nLarge Cone: bottom diameter 3", top diameter 2.5" / 4.75" height. Capacity: 12 fl oz\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.',
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:58.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
